import React from "react";
import Synonims from "./Synonims";

export default function Meaning(props) {
  return (
    <div className="Meaning">
      <h1>{props.meaning.partOfSpeech}</h1>
      {props.meaning.definitions.map(function (definition, index) {
        return (
          <div key={index}>
            <strong>Definition</strong>
            <p>{definition.definition}</p>
            <br />
            <strong>Exemple</strong>
            <br />
            <em>{definition.exemple}</em>
            <strong>Synonims : </strong>
            <Synonims synonims={definition.synonyms} />
            <strong>Phonetics : </strong>
            <span>{definition.phonetics}</span>
          </div>
        );
      })}
    </div>
  );
}
